import { IonButton, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText, IonInput, IonSpinner } from "@ionic/react"
import Head from "../Header"
import Sidebar from "../Sidebar"
import DataTable from "react-data-table-component";
import { useEffect, useState, useMemo } from "react";
import { useHistory } from "react-router";
import service from "../../Service/service";
import swal from 'sweetalert';
import Select from "react-select"
import "../../theme/style2.css"
import { Modal } from "react-bootstrap";
import { searchOutline, chevronDownOutline } from "ionicons/icons";
import DatePicker from "react-date-picker";
import moment from "moment";

const MissingTimesheetReport: React.FC = () => {

    const history = useHistory();
    const [modalopen, setModalopen] = useState(false);
    const [timeSheets, setTimeSheets] = useState([])
    const [roleuser] = useState(localStorage.getItem("UserRole"));
    const [fromDate, setFromDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [month, setmonth] = useState(null)
    const [selectedEmployeeName, setSelectedEmployeeName] = useState('');
    const [selectedEmployeeCode, setSelectedEmployeeCode] = useState('');
    const [createdBy]: any = useState(localStorage.getItem("SignupEmpId"));
    const [searchClicked, setSearchClicked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [sortorder, setSortorder] = useState(null);
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    const [hasData, setHasData] = useState(false);
    const [safariMonth, setSafariMonth] = useState(null);

    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [data, setData] = useState([]);
    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

//--------------------View in Modal------------------------//

    const View = (employeeName: string, employeeCode: string, timeSheetsData: any) => {
        setTimeSheets(timeSheetsData);
        setModalopen(true);
        setSelectedEmployeeName(employeeName);
        setSelectedEmployeeCode(employeeCode);
    }
    const closemodal = () => {
        setModalopen(false);
    }
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const startDateOfMonth = new Date(year, currentDate.getMonth(), 1);
        const startDay = String(startDateOfMonth.getDate()).padStart(2, '0');
    }, []);

//-----------------Get month-------------------//

    function getMaxMonth() {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        return `${year}-${month.toString().padStart(2, '0')}`;
    }
    // const [selectedOption, setSelectedOption] = useState(null);
    // const [inputValue, setInputValue] = useState('');
    // const [isFocused, setIsFocused] = useState(false);
    // const [menuIsOpen, setMenuIsOpen] = useState(false);

    // const handleStateChange = (selectedOption: any) => {
    //     setSelectedOption(selectedOption);
    // };

    // const handleInputChange = (inputValue: any) => {
    //     setInputValue(inputValue);
    // };

    // const handleMenuOpen = () => {
    //     setMenuIsOpen(true);
    // };

    // const handleMenuClose = () => {
    //     setMenuIsOpen(false);
    // };

    // const handleFocus = () => {
    //     setIsFocused(true);
    // };

    // const handleBlur = () => {
    //     setIsFocused(false);
    // };

    // // const customIconStyle = {
    // //   fontSize: '24px',
    // //   color: 'blue',
    // // };

    // const Placeholder = () => {
    //     if (inputValue === '' && !selectedOption && !isFocused) {
    //         return <span style={{ color: "black" }}>Select To Sort</span>;
    //     } else {
    //         return <span style={{ color: "black" }}>Type to Search Here...</span>;
    //     }
    // };

    // const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
    //     const [isClicked, setIsClicked] = useState(false);

    //     useEffect(() => {
    //         if (isClicked && !selectProps.menuIsOpen) {
    //             setIsClicked(false);
    //         }
    //     }, [selectProps.menuIsOpen]);

    //     let icon;
    //     if (isClicked || selectProps.menuIsOpen) {
    //         icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
    //     } else {
    //         icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
    //     }

    //     const handleIconClick = () => {
    //         setIsClicked(true);
    //     };

    //     return (
    //         <div {...innerProps}>
    //             <div onClick={handleIconClick}>{icon}</div>
    //         </div>
    //     );
    // };

    // const options = [
    //     { value: '1', label: 'Bussiness Unit' },
    //     { value: '2', label: 'Department Unit' },
    //     { value: '3', label: 'Employee' },
    // ];

    // const handleChange = (selectedOption: any) => {
    //     setSortorder(selectedOption.value); // Update the state with the selected option
    // };

    //---------------Getall missingtimesheet Datatable-------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px",
        },

        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit.businessUnitName,
            sortable: true,
            sort: "businessUnitName",
            width: "300px",
            cell: (itm: any) => {
                if (itm.businessUnit && itm.businessUnit.businessUnitName !== null && itm.businessUnit.businessUnitName !== undefined) {
                    return itm.businessUnit.businessUnitName;
                } else {
                    return 'NULL';
                }
            },
        },
        {
            name: "Department Unit",
            selector: (itm: any) => itm.masterDepartment.departmentName,
            sortable: true,
            sort: "departmentName",
            width: "200px",
            cell: (itm: any) => {
                if (itm.masterDepartment && itm.masterDepartment.departmentName !== null && itm.masterDepartment.departmentName !== undefined) {
                    return itm.masterDepartment.departmentName;
                } else {
                    return 'NULL';
                }
            },
        },

        {
            name: "Employee Name",
            selector: (itm: any) => itm.employeeName,
            sortable: true,
            sort: "employeeName",
            width: "300px",
            cell: (itm: any) => (
                <>
                    <div>{itm.employeeName}{" ("}{itm.employeeId}{")"}</div>
                </>
            )
        },
        {
            name: "Week",
            selector: (itm: any) => itm.week,
            sortable: true,
            width: "200px"
        },
        {
            name: "Action",
            sortable: false,
            cell: (itm: any) => (
                <div style={{ textDecoration: 'underline', textDecorationColor: "coral", textUnderlinePosition: "under" }}>
                    <IonText onClick={() => View(itm.employeeName, itm.employeeId, itm.timeSheets)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                </div>
            )
        }
    ];

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                justifyContent: "center"
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center"
            }
        }
    };

//-------------------Search Filter---------------------//

    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);
    // useEffect(() => {
    //     MissingTimesheet();
    // }, []);

//-----------Missing Timesheet Api-------------//

const MissingTimesheet = () => {
    if (month === null) {
        swal("", "Please Select Month & Year", "info");
    } else {
        const month1 = moment(month).format("YYYY-MM");
        setIsLoading(true);
        service.MissingEmployee(Id, month1)
            .then((response) => {
                console.log(Id, "Signupid");
                console.log(response);
                if (response.data.Status === "200") {
                    setData(response.data.Data);
                    setHasData(true);
                } else {
                    setData([]);
                    setHasData(false);
                }
            })
            .catch((error) => {
                swal(error);
            })
            .finally(() => {
               
                setTimeout(() => {
                    setIsLoading(false); 
                }, 500); 
            });
    }
}

//---------------Missing Timesheet Pdf Api---------------//

    const MissingTimesheetPdf = () => {
        setIsLoading(true);
        setTimeout(() => {
            if (month === null) {
                setIsLoading(false);
                swal("", "Please Select Month & Year", "info");
            } else {
                // service.MissingEmployeePdf(Id, month, sortorder)
                const month1 = moment(month).format("YYYY-MM");
                service.MissingEmployeePdf(Id, month1)
                    .then((response) => {
                        console.log(Id, "Signupid");
                        console.log(response);
                        if (response.data.Status === "200") {
                            setData(response.data.Data);
                            
                        } else {
                            // setData([])
                        }
                    })
                    .catch((error) => {
                        swal(error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }

        }, 1500);
    };

    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Time Sheet Missing Report </h3>
                                </div>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Month & Year <span className="text-danger">*</span></label>
                                        <div>
                                            {/* <IonInput value={month} onIonChange={(e: any) => setmonth(e.target.value)} type="month" className="form-control datetimepicker" max={getMaxMonth()} /> */}
                                            <DatePicker clearIcon={null} maxDetail="year" format="MM/yyyy" value={month} className="form-control" onChange={(e: any) => setmonth(e)} />
                                        </div>
                                    </div>

                                </div>
                                {/* <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Sorting <span className="text-danger">*</span></label>
                                        <div>
                                            <Select
                                                value={options.find((option) => option.value === sortorder) || null}
                                                onChange={handleChange}
                                                options={options}
                                                onInputChange={handleInputChange}
                                                onMenuOpen={handleMenuOpen}
                                                onMenuClose={handleMenuClose}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                menuIsOpen={menuIsOpen}
                                                isSearchable
                                                placeholder={<Placeholder />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicator,
                                                }}
                                                className="custom-select2"
                                            />
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="col-sm-6 col-md-4">
                                    <div className="form-group">
                                        <label style={{ fontWeight: 'bold' }}>From Date</label>
                                        <div>
                                            <input
                                                type="date"
                                                value={fromDate}
                                                onChange={handleFromDateChange}
                                                min="2023-06-01"
                                                max={getCurrentDate()}
                                                className="form-control datetimepicker"
                                            />
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="col-sm-6 col-md-4">
                                    <div className="form-group">
                                        <label style={{ fontWeight: 'bold' }}>To Date</label>
                                        <div>
                                            <input
                                                type="date"
                                                value={endDate}
                                                onChange={handleEndDateChange}
                                                min="2023-06-01"
                                                max={getCurrentDate()}
                                                className="form-control datetimepicker"
                                            />
                                        </div>
                                    </div>
                                </div> */}
                                <div className="col-sm-6 col-md-3" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                    <button className="btn btn-orange btn-block w-100"
                                        onClick={() => {
                                            MissingTimesheet();
                                            setSearchClicked(true);

                                        }}>
                                        VIEW REPORT
                                    </button>
                                </div>
                                <div className="col-sm-6 col-md-3 col-lg-3" style={{ display: 'flex', alignSelf: 'center', justifySelf: 'center' }}>
                                    <button
                                        onClick={MissingTimesheetPdf}
                                        className="btn btn-success btn-block w-100 "
                                    ><i className="la la-file-pdf-o" />
                                        Generate pdf
                                    </button>
                                </div>
                            </div>
                            {hasData ? (
                                // If there is data, display the table
                                <div className="table-responsive">
                                    <DataTable
                                        className="table-responsive"
                                        columns={columns}
                                        data={datatable}
                                        pagination
                                        paginationPerPage={10}
                                        paginationComponentOptions={paginationComponentOptions}
                                        paginationRowsPerPageOptions={[10, 20, 30]}
                                        subHeader
                                        subHeaderComponent={subHeaderComponent}
                                        customStyles={customStyles}
                                    />
                                </div>
                            ) : (
                                <></>
                                // If there is no data, display the "No data found" message
                                // <div>No data found</div><
                            )}
                        </div>

                    </div>
                    <Modal dialogClassName="modal-dialog modal-lg" show={modalopen}>
                        <div className="modal-header">
                            <h5 className="modal-title">{selectedEmployeeName} ({selectedEmployeeCode}) – Missing Timesheet </h5>
                            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="form-group" style={{ marginTop: "2%" }}>
                                    {/* <label style={{ fontWeight: "bold" }}>Pending Timesheet</label> */}
                                    <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                        {timeSheets && timeSheets.length > 0 && timeSheets.map((itm: any) => (
                                            <li key={itm.id}>{itm}</li>
                                        ))}
                                    </div>
                                </div>
                            </form>

                        </div>

                    </Modal>

                    <div>
                        {isLoading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div>
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}

                    </div>
                </div>

            </IonContent>
        </IonPage>
    )
}

export default MissingTimesheetReport